// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__qO-jV","inputDescription":"styles_inputDescription__33Zph"};